import { css } from 'lit-element';
/* @internal */
export const styles = css `cds-datalist input::-webkit-calendar-picker-indicator{display:none}
`;
//# sourceMappingURL=datalist-global.element.css.js.map